module.exports = __webpack_public_path__ + "img/Blonix.377da6c3.jpg";